import { TemplateNavFooterBasicStyles } from "./NavFooter-Level0.styles"

const t = document.createElement('template')
t.innerHTML = `
<li class="ascend-footer__item">
  <slot></slot>
</li>
`
const TemplateNavFooterBasicLink = t

class NavFooterBasicLink extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavFooterBasicStyles.content.cloneNode(true))
    shadow.appendChild(TemplateNavFooterBasicLink.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavFooterBasicLink connectedCallback')
  }
}

// legacy
//customElements.define('ts-navfooter-basic-link', NavFooterBasicLink)
// new
if (!customElements.get('ts-navfooter-level0-link')) {
  customElements.define('ts-navfooter-level0-link', NavFooterBasicLink)
}
export { NavFooterBasicLink }
